module.exports = __webpack_public_path__ + "b813c674540d1a6212f64e37838bc621.png";